/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { PhaseDto } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Get All
 */
export const getPhase = (signal?: AbortSignal) => {
  return customInstance<PhaseDto[]>({ url: `/phase`, method: "GET", signal });
};

export const getGetPhaseInfiniteQueryKey = () => {
  return ["infinite", `/phase`] as const;
};

export const getGetPhaseQueryKey = () => {
  return [`/phase`] as const;
};

export const getGetPhaseInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getPhase>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPhase>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPhaseInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPhase>>> = ({
    signal,
  }) => getPhase(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPhase>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPhaseInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhase>>
>;
export type GetPhaseInfiniteQueryError = void;

export function useGetPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPhase>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhase>>,
          TError,
          Awaited<ReturnType<typeof getPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPhase>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhase>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhase>>,
          TError,
          Awaited<ReturnType<typeof getPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPhase>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetPhaseInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPhase>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhase>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPhaseInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPhaseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPhase>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getPhase>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPhaseQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPhase>>> = ({
    signal,
  }) => getPhase(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPhase>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetPhaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhase>>
>;
export type GetPhaseQueryError = void;

export function useGetPhase<
  TData = Awaited<ReturnType<typeof getPhase>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhase>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhase>>,
          TError,
          Awaited<ReturnType<typeof getPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhase<
  TData = Awaited<ReturnType<typeof getPhase>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhase>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhase>>,
          TError,
          Awaited<ReturnType<typeof getPhase>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhase<
  TData = Awaited<ReturnType<typeof getPhase>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhase>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetPhase<
  TData = Awaited<ReturnType<typeof getPhase>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhase>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPhaseQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create
 */
export const postPhase = (phaseDto: PhaseDto, signal?: AbortSignal) => {
  return customInstance<PhaseDto>({
    url: `/phase`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: phaseDto,
    signal,
  });
};

export const getPostPhaseMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPhase>>,
    TError,
    { data: PhaseDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPhase>>,
  TError,
  { data: PhaseDto },
  TContext
> => {
  const mutationKey = ["postPhase"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPhase>>,
    { data: PhaseDto }
  > = (props) => {
    const { data } = props ?? {};

    return postPhase(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPhaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPhase>>
>;
export type PostPhaseMutationBody = PhaseDto;
export type PostPhaseMutationError = void;

/**
 * @summary Create
 */
export const usePostPhase = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPhase>>,
      TError,
      { data: PhaseDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postPhase>>,
  TError,
  { data: PhaseDto },
  TContext
> => {
  const mutationOptions = getPostPhaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update
 */
export const putPhaseId = (id: number, phaseDto: PhaseDto) => {
  return customInstance<PhaseDto>({
    url: `/phase/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: phaseDto,
  });
};

export const getPutPhaseIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putPhaseId>>,
    TError,
    { id: number; data: PhaseDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putPhaseId>>,
  TError,
  { id: number; data: PhaseDto },
  TContext
> => {
  const mutationKey = ["putPhaseId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putPhaseId>>,
    { id: number; data: PhaseDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return putPhaseId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutPhaseIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putPhaseId>>
>;
export type PutPhaseIdMutationBody = PhaseDto;
export type PutPhaseIdMutationError = void;

/**
 * @summary Update
 */
export const usePutPhaseId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putPhaseId>>,
      TError,
      { id: number; data: PhaseDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putPhaseId>>,
  TError,
  { id: number; data: PhaseDto },
  TContext
> => {
  const mutationOptions = getPutPhaseIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find By Id
 */
export const getPhaseId = (id: number, signal?: AbortSignal) => {
  return customInstance<PhaseDto>({
    url: `/phase/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetPhaseIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/phase/${id}`] as const;
};

export const getGetPhaseIdQueryKey = (id?: number) => {
  return [`/phase/${id}`] as const;
};

export const getGetPhaseIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getPhaseId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhaseId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPhaseIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPhaseId>>> = ({
    signal,
  }) => getPhaseId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPhaseId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPhaseIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhaseId>>
>;
export type GetPhaseIdInfiniteQueryError = void;

export function useGetPhaseIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPhaseId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhaseId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhaseId>>,
          TError,
          Awaited<ReturnType<typeof getPhaseId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhaseIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPhaseId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhaseId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhaseId>>,
          TError,
          Awaited<ReturnType<typeof getPhaseId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhaseIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPhaseId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhaseId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetPhaseIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPhaseId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhaseId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPhaseIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPhaseIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getPhaseId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhaseId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPhaseIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPhaseId>>> = ({
    signal,
  }) => getPhaseId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPhaseId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPhaseIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhaseId>>
>;
export type GetPhaseIdQueryError = void;

export function useGetPhaseId<
  TData = Awaited<ReturnType<typeof getPhaseId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhaseId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhaseId>>,
          TError,
          Awaited<ReturnType<typeof getPhaseId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhaseId<
  TData = Awaited<ReturnType<typeof getPhaseId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhaseId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhaseId>>,
          TError,
          Awaited<ReturnType<typeof getPhaseId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhaseId<
  TData = Awaited<ReturnType<typeof getPhaseId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhaseId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Find By Id
 */

export function useGetPhaseId<
  TData = Awaited<ReturnType<typeof getPhaseId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPhaseId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPhaseIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete
 */
export const deletePhaseId = (id: number) => {
  return customInstance<boolean>({ url: `/phase/${id}`, method: "DELETE" });
};

export const getDeletePhaseIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePhaseId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePhaseId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deletePhaseId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePhaseId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deletePhaseId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePhaseIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePhaseId>>
>;

export type DeletePhaseIdMutationError = void;

/**
 * @summary Delete
 */
export const useDeletePhaseId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deletePhaseId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deletePhaseId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeletePhaseIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get All By Project Id
 */
export const getPhaseIdProject = (id: number, signal?: AbortSignal) => {
  return customInstance<PhaseDto[]>({
    url: `/phase/${id}/project`,
    method: "GET",
    signal,
  });
};

export const getGetPhaseIdProjectInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/phase/${id}/project`] as const;
};

export const getGetPhaseIdProjectQueryKey = (id?: number) => {
  return [`/phase/${id}/project`] as const;
};

export const getGetPhaseIdProjectInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getPhaseIdProject>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhaseIdProject>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPhaseIdProjectInfiniteQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPhaseIdProject>>
  > = ({ signal }) => getPhaseIdProject(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getPhaseIdProject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPhaseIdProjectInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhaseIdProject>>
>;
export type GetPhaseIdProjectInfiniteQueryError = void;

export function useGetPhaseIdProjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPhaseIdProject>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhaseIdProject>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhaseIdProject>>,
          TError,
          Awaited<ReturnType<typeof getPhaseIdProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhaseIdProjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPhaseIdProject>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhaseIdProject>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhaseIdProject>>,
          TError,
          Awaited<ReturnType<typeof getPhaseIdProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhaseIdProjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPhaseIdProject>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhaseIdProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Project Id
 */

export function useGetPhaseIdProjectInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getPhaseIdProject>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getPhaseIdProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPhaseIdProjectInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetPhaseIdProjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getPhaseIdProject>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhaseIdProject>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPhaseIdProjectQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPhaseIdProject>>
  > = ({ signal }) => getPhaseIdProject(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPhaseIdProject>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPhaseIdProjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPhaseIdProject>>
>;
export type GetPhaseIdProjectQueryError = void;

export function useGetPhaseIdProject<
  TData = Awaited<ReturnType<typeof getPhaseIdProject>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhaseIdProject>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhaseIdProject>>,
          TError,
          Awaited<ReturnType<typeof getPhaseIdProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhaseIdProject<
  TData = Awaited<ReturnType<typeof getPhaseIdProject>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhaseIdProject>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPhaseIdProject>>,
          TError,
          Awaited<ReturnType<typeof getPhaseIdProject>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPhaseIdProject<
  TData = Awaited<ReturnType<typeof getPhaseIdProject>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhaseIdProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Project Id
 */

export function useGetPhaseIdProject<
  TData = Awaited<ReturnType<typeof getPhaseIdProject>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPhaseIdProject>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPhaseIdProjectQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
